import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useActionInstance } from '@integration-app/react';
import { LogoLoader } from '../../LogoLoader';
const ActionInstanceContext = createContext({
    actionInstance: null,
    loading: false,
    patch: () => Promise.resolve(),
    setup: () => Promise.resolve(),
    reset: () => Promise.resolve(),
    refresh: () => Promise.resolve(),
});
export function useActionInstanceContext() {
    return useContext(ActionInstanceContext);
}
export const ActionInstanceContextProvider = ({ children, id, fallback, }) => {
    const { actionInstance, patch, setup, reset, refresh, loading } = useActionInstance(id);
    if (loading) {
        return fallback ? fallback() : _jsx(LogoLoader, {});
    }
    return (_jsx(ActionInstanceContext.Provider, { value: {
            actionInstance,
            patch,
            setup,
            reset,
            refresh,
            loading,
        }, children: children }));
};
//# sourceMappingURL=action-instance-context.js.map